import { render, staticRenderFns } from "./MoneyComponent2.vue?vue&type=template&id=71a76a88&scoped=true&"
import script from "./MoneyComponent2.vue?vue&type=script&lang=js&"
export * from "./MoneyComponent2.vue?vue&type=script&lang=js&"
import style0 from "./MoneyComponent2.vue?vue&type=style&index=0&id=71a76a88&scoped=true&lang=css&"
import style1 from "./MoneyComponent2.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a76a88",
  null
  
)

export default component.exports